import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from '@chatterbug/aaron'

const LearningLanguageLevelAssessmentSkeleton = ({
  LogoSection,
  SelfAssessmentSection,
  PlacementTestSection,
}) => {
  return (
    <Grid gridGap="6x" justifyItems="center" width="100%">
      {LogoSection}
      <Grid sx={{ width: '100%' }} gridGap="3x" justifyItems="center">
        {SelfAssessmentSection}
        {PlacementTestSection}
      </Grid>
    </Grid>
  )
}

LearningLanguageLevelAssessmentSkeleton.propTypes = {
  LogoSection: PropTypes.any,
  SelfAssessmentSection: PropTypes.any,
  PlacementTestSection: PropTypes.any,
}

export default LearningLanguageLevelAssessmentSkeleton
